import BaseModel from './base'
import { registerModel } from './registry'
import { isUnknownObject } from '~/shared/utils/guards'
import type { PaginationData } from '~/shared/interfaces'

export default class PaginationDataModel extends BaseModel implements PaginationData {
  static override constructorName = 'PaginationDataModel'

  currentPage: number = 1
  lastPage: number = 1
  perPage: number = 0
  total: number = 0
  count: number = 0
  hasMorePages: boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      this.currentPage = Number(data.current_page ?? this.currentPage)
      this.lastPage = Number(data.last_page ?? this.lastPage)
      this.perPage = Number(data.per_page ?? this.perPage)
      this.total = Number(data.total ?? this.total)
      this.count = Number(data.count ?? this.count)
      this.hasMorePages = this.currentPage < this.lastPage
    }
  }
}

registerModel(PaginationDataModel)
